"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _default = (0, _unmutable["default"])({
  name: 'push',
  immutable: 'push',
  array: function array() {
    for (var _len = arguments.length, newValues = new Array(_len), _key = 0; _key < _len; _key++) {
      newValues[_key] = arguments[_key];
    }

    return function (value) {
      return [].concat((0, _toConsumableArray2["default"])(value), newValues);
    };
  }
});

exports["default"] = _default;